import { Injectable } from '@angular/core';
import * as ExcelJs from 'exceljs';
import {saveAs} from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class ExceljsServiceService {

  constructor() { }

  async readExcel(file: File): Promise<any[]> {

    const workbook = new ExcelJs.Workbook();

    const buffer = await file.arrayBuffer();

    await workbook.xlsx.load(buffer);

    const worksheet = workbook.worksheets[0];

    const headers: string[] = [];
    const data: any[] = [];

    worksheet.getRow(1).eachCell((cell) => {
      headers.push(String(cell.value ?? '').trim());
    });

    worksheet.eachRow((row, rowNumber) => {

      if (rowNumber === 1) {
        return;
      }

      const rowData: any = {};

      headers.forEach((header, index) => {
        rowData[header] = row.getCell(index + 1).value ?? '';
      });

      data.push(rowData);

    });

    return data;
  }

   async downloadExcel(headers: string[], data: any[], fileName: string, sheetName: string = 'Sheet1'): Promise<void> {

    const workbook = new ExcelJs.Workbook();
    const worksheet = workbook.addWorksheet(sheetName);

    worksheet.columns = headers.map(header => ({header,key: header, width: 25 }));

    data.forEach(row => {
      worksheet.addRow(row);
    });

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob(
      [buffer],
      {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    );

    saveAs(blob, fileName);
  }

  /** Apply fixed column widths (1-based order). */
  applyColumnWidths(worksheet: ExcelJs.Worksheet, widths: number[]): void {
    widths.forEach((width, index) => {
      worksheet.getColumn(index + 1).width = width;
    });
  }

  /**
   * Keep long text inside its own cell (wrap + top align).
   * Optional height estimate so multi-line / JSON values remain readable.
   */
  applyCellTextWrap(
    row: ExcelJs.Row,
    options?: { estimateFromValues?: string[]; minHeight?: number; maxHeight?: number }
  ): void {
    row.alignment = {
      ...(row.alignment || {}),
      wrapText: true,
      vertical: 'top'
    };

    const values = options?.estimateFromValues;
    if (!values?.length) {
      return;
    }

    const minHeight = options?.minHeight ?? 18;
    const maxHeight = options?.maxHeight ?? 180;
    let lineCount = 1;
    values.forEach((value) => {
      const text = String(value ?? '');
      const explicitLines = text.split(/\r?\n/).length;
      const wrapEstimate = Math.ceil(text.length / 42);
      lineCount = Math.max(lineCount, explicitLines, wrapEstimate);
    });
    row.height = Math.min(maxHeight, Math.max(minHeight, lineCount * 14));
  }
  
  async readExcelAsMatrix(file: File): Promise<any[][]> {

   const extension =
    file.name.split('.').pop()?.toLowerCase(); 

  if (extension === 'csv') {

    const text = await file.text();

    return text
      .split(/\r?\n/)
      .filter(row => row.trim() !== '')
      .map(row => row.split(','));
  }

  const workbook = new ExcelJs.Workbook();

  const buffer = await file.arrayBuffer();

  await workbook.xlsx.load(buffer);

  const worksheet = workbook.worksheets[0];

  if (!worksheet) {
    return [];
  }

  const jsonData: any[][] = [];

  worksheet.eachRow((row) => {

    const rowValues = row.values as any[];

    jsonData.push(
      rowValues.slice(1)
    );

  });

  return jsonData;
}

}